import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initial-state";

const { actions, reducer } = createSlice({
  name: "searchProfile",
  initialState,
  reducers: {
    setCounterIncrement(state) {
      state.counter += 1;
    },
    setCounterDecrement(state) {
      state.counter -= 1;
    },
    setAllProfiles(state, actions) {
      state.profiles = actions.payload;
    },
    setTotalPage(state, actions) {
      state.pagination.totalPage = actions.payload;
    },
    setCurrentPage(state, actions) {
      state.pagination.currentPage = actions.payload;
    },
    setSearch(state, actions) {
      state.search = actions.payload;
    },
    setSort(state, actions) {
      state.sort = actions.payload;
    },
    setFilter(state, actions) {
      state.filter = actions.payload;
    },
    setSelectedRasi(state, actions) {
      state.filter.rasi = actions.payload;
    },
    setSelectedNakshatra(state, actions) {
      state.filter.nakshatra = actions.payload;
    },
    setProfileAvailability(state, actions) {
      state.filter.profilesAvailability = actions.payload;
    },
    setMinAge(state, actions) {
      state.filter.minAge = actions.payload;
    },
    setMaxAge(state, actions) {
      state.filter.maxAge = actions.payload;
    },
    setPageLimit(state, actions) {
      state.pageLimit = actions.payload;
    },
  },
});

export { actions };
export default reducer;
